export const button = {
  root: ({ props, context }: Record<string, any>) => ({
    class: [
      'tw-relative',
      'tw-font-sans tw-box-border tw-h-11 tw-border tw-rounded tw-px-4 tw-py-5 tw-font-base tw-font-bold tw-leading-normal tw-outline-none tw-transition-[background-color,color] tw-duration-150 tw-ease-in-out tw-no-underline',

      // Alignments
      'tw-items-center tw-inline-flex tw-text-center tw-align-bottom tw-justify-center',
      { 'tw-gap-2': props.label !== null },

      // Primary Button
      {
        'tw-text-black tw-bg-primary-600 tw-border tw-border-primary':
          !props.link && props.severity === null && !props.text && !props.outlined && !props.plain,
        'hover:tw-bg-primary-700 hover:tw-border-primary-700':
          !props.link && props.severity === null && !props.text && !props.outlined && !props.plain,
        'focus:tw-ring-primary': props.severity === null,
      },

      'focus:tw-outline-none focus:tw-outline-offset-0 focus:tw-ring-1',

      // Disabled
      { 'tw-opacity-60 tw-pointer-events-none tw-cursor-default': context.disabled },
      { 'tw-cursor-pointer': !context.disabled },

      // Misc
      'tw-overflow-hidden tw-select-none',
    ],
  }),
  label: ({ props }: Record<string, any>) => ({
    class: [
      'tw-duration-200',
      'tw-font-medium',
      { 'tw-flex-1': props.label !== null, 'tw-invisible tw-w-0': props.label == null },
    ],
  }),
};
